// extracted by mini-css-extract-plugin
export default {"header":"styles_header__r+OuC","breadcrumbsWrapper":"styles_breadcrumbsWrapper__5uaym","logoLink":"styles_logoLink__8SYZr","sider":"styles_sider__H7oHG"};